/*
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-10-08 17:00:12
 * @LastEditors: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @LastEditTime: 2023-10-08 17:00:48
 * @FilePath: \合联\oms\src\api\analysis\abnormalArrivalTrajectory.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios, { buildApi } from '@/libs/api.request';
let name = '/report/tracker/'

export const apis = buildApi({
  get: [name + '/log&list',],
  post: [name + '/complete',]
})